import React from 'react';
import { connect } from 'react-redux';
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { dateTime } from '../../utils/parsing';
import { muteAlertAction } from '../../redux/actions/alerts';
import Collapsible from '../util/Collapsible';

import './alerts.css';

const nonMutedCount = (alerts, filter) => alerts.filter(filter).filter((a) => !a.muted).length;

const ActiveAlerts = ({
  latestOnly,
  count,
  toggleAlertMute,
  filter = () => true,
  hiddenWhenEmpty = false,
}) =>
  hiddenWhenEmpty && count === 0 ? null : (
    <Collapsible headerContent={`${count} Active alerts`} defaultOpen={count > 0}>
      <Table className="active-alerts">
        <TableHead>
          <TableRow>
            <TableCell>Message</TableCell>
            <TableCell>Fired at</TableCell>
            <TableCell>Muted?</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {latestOnly.filter(filter).map((alert) => (
            <TableRow key={alert.key} className={`alert-row ${alert.muted ? 'muted' : 'firing'}`}>
              <TableCell>{alert.message}</TableCell>
              <TableCell>{dateTime(alert.timestamp)}</TableCell>
              <TableCell>
                <Checkbox checked={alert.muted} onChange={() => toggleAlertMute(alert)} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Collapsible>
  );

export default connect(
  (
    {
      entities: {
        alerts: { latestOnly },
      },
    },
    { filter }
  ) => ({ latestOnly, count: nonMutedCount(latestOnly, filter) }),
  (dispatch) => ({
    toggleAlertMute: (alert) => dispatch(muteAlertAction(alert.key, alert.timestamp, !alert.muted)),
  })
)(ActiveAlerts);
